import {
    MapOptions
} from "@esdm/map/dist";
import { DerbyshireBaseLayerTypes } from "./DerbyshireBaseMapping_3857";


export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();              
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [DerbyshireBaseLayerTypes.OSM, DerbyshireBaseLayerTypes.DerbyshireOS, DerbyshireBaseLayerTypes.DerbyshireAerial];
        opt.defaultBaseMap = DerbyshireBaseLayerTypes.OSM;
        opt.enableBoundsTracking = true;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 13;
        opt.minZoom = 9;
        opt.maxZoom = 19;
        opt.extent = [-230699, 6923187, -82717, 7095195];
        opt.mapCentre = [-163575, 6969069];
        opt.displayProjection = "EPSG:3857";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;        
        opt.zoomToNearestBounds = false;
        return opt;
    }

}